// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"39":"a47850ca","43":"6475284c","64":"97904aa9","107":"0539e03d","119":"4a5a8be9","182":"95550b62","296":"7c119aae","394":"bb685c3e","498":"aeb7fa29","613":"8f260429","772":"e939dea8","825":"f6e5b756","932":"98c9c202"}[chunkId] + ".js";
};